import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const TablePaginationSummaryWrapper = styled.section`
  margin-right: ${Spacing.S16};
`
